"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.emptyTemplate = void 0;
exports.emptyTemplate = { id: 1 };
//# sourceMappingURL=empty-template.js.map